import { CATEGORY } from './const';
import { useFileDialog } from '@vueuse/core';
// 提取文件数据
export const getFileDataAtom = {
    id: 'xy:getFileData',
    name: '提取文件数据',
    desc: '仅支持提取文本类文件数据\n如JSON/CSV/SQL/纯文本文件',
    category: CATEGORY.EXPORT,
    paramsSchema: {
        type: 'object',
        fields: [
            {
                id: 'multiple',
                type: 'boolean',
                title: '是否支持多选',
                default: false,
                condition: '!params.enableDirectory',
            },
            {
                id: 'enableDirectory',
                type: 'boolean',
                title: '是否支持选择文件夹',
                default: false,
                condition: '!params.multiple',
            },
            {
                id: 'codepage',
                type: 'string',
                title: '字符集',
                enum: [
                    {
                        label: '默认',
                        value: '',
                    },
                    {
                        label: 'UTF-8',
                        value: 'UTF-8',
                    },
                    {
                        label: 'GBK / GB2312',
                        value: 'GBK',
                    },
                ],
                default: '',
            },
        ],
    },
    execute: async (_ctx, params) => {
        const { multiple = false, enableDirectory = false, codepage = '' } = params;
        const acceptSuffix = ['.sql', '.pck'];
        const acceptType = ['text/plain', 'application/json', 'text/csv'];
        const acceptTypeStr = [...acceptType, ...acceptSuffix].join(',');
        const result = await new Promise((rs, rj) => {
            const { open, onCancel, onChange } = useFileDialog({
                accept: acceptTypeStr,
                multiple,
                directory: enableDirectory,
            });
            onChange((rawFiles) => {
                if (!rawFiles?.length)
                    rs(null);
                const files = Array.from(rawFiles)
                    .filter(file => acceptType.includes(file.type) || acceptSuffix.some(suffix => file.name.endsWith(suffix)));
                if (!files.length)
                    rj(new Error('不支持该文件类型'));
                const fileData = {};
                const fileObjects = {};
                const readerPromises = files.map(file => new Promise((resolveReader) => {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        const data = e?.target?.result;
                        if (!data || typeof data !== 'string') {
                            fileData[file.name] = '';
                        }
                        else {
                            fileData[file.name] = data;
                        }
                        fileObjects[file.name] = file;
                        resolveReader();
                    };
                    if (codepage) {
                        reader.readAsText(file, codepage);
                    }
                    else {
                        reader.readAsText(file);
                    }
                }));
                Promise.all(readerPromises).then(() => {
                    if (multiple || enableDirectory) {
                        rs({ data: fileData, __file__: fileObjects });
                    }
                    else {
                        rs({ data: Object.values(fileData)[0], __file__: Object.values(fileObjects)[0] });
                    }
                }, (err) => {
                    rj(new Error(`文件提取错误${err}`));
                });
            });
            onCancel(() => rs(null));
            open();
        });
        return result;
    },
    returnValue: {
        type: 'object',
        fields: [
            {
                id: 'data',
                type: 'object',
                description: '文件数据',
            },
            {
                id: '__file__',
                type: 'object',
                description: '文件对象',
            },
        ],
    },
};
